import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '../ui/card';
import type { Send } from '../../types/send';
import type { GradingSystemWithGrades } from '../../types/gym';
import { gradeName } from '../../utils/stats-utils';

interface StatsSummaryRowProps {
  sends: Send[];
  gradingSystem: GradingSystemWithGrades | null | undefined;
}

export default function StatsSummaryRow({ sends, gradingSystem }: StatsSummaryRowProps) {
  const { t } = useTranslation();

  const onSightCount = sends.filter(s => s.attributes.send_type === 'on_sight').length;
  const flashCount = sends.filter(s => s.attributes.send_type === 'flash').length;

  const maxDifficultyValue = sends.reduce<number | null>((max, s) => {
    const v = s.attributes.climb.difficulty_value;
    if (v == null) return max;
    return max == null ? v : Math.max(max, v);
  }, null);

  const maxGradeLabel =
    maxDifficultyValue != null && gradingSystem
      ? gradeName(maxDifficultyValue, gradingSystem.grades)
      : '—';

  const metrics = [
    { label: t('stats.summary.totalSends'), value: sends.length },
    { label: t('stats.summary.onSight'), value: onSightCount },
    { label: t('stats.summary.flash'), value: flashCount },
    { label: t('stats.summary.maxGrade'), value: maxGradeLabel },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {metrics.map(({ label, value }) => (
        <Card key={label}>
          <CardContent className="flex flex-col items-center justify-center p-4 text-center">
            <span className="text-2xl font-bold">{value}</span>
            <span className="mt-1 text-xs text-muted-foreground">{label}</span>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
